import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeHighlight from 'rehype-highlight';
import AssistantIcon from '@mui/icons-material/Assistant';

const AnalystFullscreen = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const stored = sessionStorage.getItem('analyst-fullscreen');
    if (stored) {
      setContent(stored);
    }
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen bg-[#404880] flex items-center justify-center">
        <p className="text-white/60 text-sm">No content to display.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#404880] p-6 md:p-12">
      <div className="max-w-4xl mx-auto bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 md:p-12">
        <div className="flex items-center gap-3 mb-6 pb-4 border-b border-gray-200">
          <AssistantIcon className="text-[#404880]" style={{ fontSize: '28px' }} />
          <h1 className="text-lg font-semibold text-gray-800">Analysis Result</h1>
        </div>
        <div className="prose prose-sm max-w-none prose-headings:text-gray-900 prose-p:text-gray-700 prose-li:text-gray-700">
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeHighlight]}
            components={{
              table: ({ children }) => (
                <div className="not-prose my-3 overflow-hidden rounded-lg border">
                  <table className="w-full text-sm">{children}</table>
                </div>
              ),
              th: ({ children }) => (
                <th className="bg-brand-pink/10 px-3 py-2 text-left font-medium text-gray-800">{children}</th>
              ),
              td: ({ children }) => (
                <td className="px-3 py-2 text-gray-600 border-t">{children}</td>
              ),
              code: ({ inline, className, children, ...props }) => inline ? (
                <code className="rounded bg-gray-100 px-1 py-0.5 text-[0.85em] text-brand-pink" {...props}>{children}</code>
              ) : (
                <pre className="my-2 overflow-auto rounded-lg border bg-gray-900 p-3 text-sm">
                  <code className={`${className} text-gray-100`} {...props}>{children}</code>
                </pre>
              ),
            }}
          >
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default AnalystFullscreen;
